module.exports = __webpack_public_path__ + "static/media/14_1.aa6fab89.png";